export { default } from "./TagManager";
